export const checkQuantityValidity = (
  quantity: number,
  minBuy: number,
  mustBuy: number,
): [boolean, string?] => {
  if (mustBuy === 1) return [true];
  const startBuy = generateQuantityOptions(minBuy, mustBuy, 1)[0] ?? 1;
  if (quantity < startBuy)
    return [false, `Please enter a quantity of ${startBuy} or more.`];
  if (quantity % mustBuy !== 0)
    return [false, `Please enter a quantity that is a multiple of ${mustBuy}.`];

  return [true];
};

export const generateQuantityOptions = (
  minimumBuy: number,
  mustBuy: number,
  length: number = 15,
): number[] => {
  let startQuantity = Math.max(minimumBuy, mustBuy);

  // handle the case when the start quantity is not divisible by must buy
  if (mustBuy > 1 && minimumBuy > mustBuy && startQuantity % mustBuy !== 0) {
    let counter = 1;
    while (mustBuy * counter < minimumBuy) {
      counter += 1;
      startQuantity = mustBuy * counter;
    }
  }

  return Array.from({ length }, (_, index) => startQuantity + index * mustBuy);
};
